import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const removeAll: SxStyleFunc<number> = (length) => ({
  justifyContent: 'center',
  display: length < 1 ? 'none' : 'flex',
  gap: 0.5,
  alignItems: 'center',
  borderWidth: '1px',
  width: (p) => p.spacing(3),
  height: (p) => p.spacing(3),
  cursor: 'pointer',
  mx: 0.5,
  transition: 'all 0.2s ease-in',

  '& > button': {
    display: 'none',
  },

  ':hover': {
    '& > svg': {
      display: length >= 2 ? 'none' : 'inline-block',
    },

    '& > button': {
      display: length >= 2 ? 'inline-block' : 'none',
    },
  },
});

export const scrollBtn: SxStyleFunc<boolean | undefined> = (
  canScrollRight
) => ({
  display: canScrollRight ? 'flex' : 'none',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.common.white,
  cursor: 'pointer',
  mx: 0.5,
  ':hover': {
    borderColor: (p) => p.palette.grey[400],
    borderRadius: '50%',
  },
});
